import { render, staticRenderFns } from "./AntarcticStationAmundsenScott.vue?vue&type=template&id=5d01e2c6&"
import script from "./AntarcticStationAmundsenScott.vue?vue&type=script&lang=js&"
export * from "./AntarcticStationAmundsenScott.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports